import localeEs from '../i18n/locale/es-ES'
import localeUS from '../i18n/locale/en-US'
import localeBR from '../i18n/locale/pt-BR'
import localePL from '../i18n/locale/pl-PL'

export const LOCALE_CONFIGS = {
  'es-ES': localeEs,
  'en-US': localeUS,
  'pt-BR': localeBR,
  'pl-PL': localePL
}